import { SurveyAnswersState } from "@utils/redux/slices/surveyAnswers";
import { RecommendedPlanState } from "../redux/slices/recommendedPlan";
import getStore from "@utils/redux/store";
import { initializeHandlers, firePixelEvent } from "../pixels/handler";
import { isHM } from "../userSegment";
import { getPromoCodeState } from "../redux/slices/promoCode";
import { getSurveyAnswers } from "src/hooks/survey/answers";
import { PurchaseProgramResponse } from "../api/purchase/checkout";
import { userHasPurchasedNoomClinical } from "../userSegment/features";

export function initConversionTracker() {
  initializeHandlers();
  firePixelEvent("init", {});
}

/**
 * Tracks the 'Lead' event.
 */
export function trackLead(email: string, surveyAnswers?: SurveyAnswersState) {
  const { userData } = getStore().getState();
  if (isHM()) {
    firePixelEvent("HMLead", { email, userData, surveyAnswers });
  } else {
    firePixelEvent("lead", { email, userData, surveyAnswers });
  }
}

/**
 * Tracks the 'Initiate Checkout' event.
 */
export function trackInitiateCheckout(
  plan: RecommendedPlanState,
  surveyAnswers: SurveyAnswersState
) {
  if (isHM()) {
    firePixelEvent("HMInitiateCheckout", { plan, surveyAnswers });
  } else {
    firePixelEvent("initiateCheckout", { plan, surveyAnswers });
  }
}

/**
 * Tracks the 'Purchase' event.
 */
export function trackPurchase(
  email: string,
  plan: RecommendedPlanState,
  surveyAnswers: SurveyAnswersState,
  order: PurchaseProgramResponse
) {
  const { userData } = getStore().getState();
  const promoCode = getPromoCodeState();
  const eventName = isHM() ? "HMPurchase" : "purchase";
  firePixelEvent(eventName, {
    email,
    plan,
    surveyAnswers,
    order,
    userData,
    promoCode,
  });
}

export function trackViewContent() {
  firePixelEvent("viewContent", {
    value: "2.00",
    currency: "USD",
  });
}

export function trackFastForwardTrial({
  discountOffered,
}: {
  discountOffered: boolean;
}) {
  const { userData } = getStore().getState();
  const surveyAnswers = getSurveyAnswers();
  firePixelEvent("trialFastForward", {
    discountOffered,
    email: userData.email || surveyAnswers.email || "",
    userData,
  });
}

export function trackNoomPremium(signupEltv13: number, products: string[]) {
  if (userHasPurchasedNoomClinical()) {
    return Promise.resolve();
  }
  const { userData } = getStore().getState();
  const surveyAnswers = getSurveyAnswers();
  return firePixelEvent("noomPremium", {
    signupEltv13,
    products,
    email: userData.email || surveyAnswers.email || "",
    userData,
  });
}

export function trackNoomSummit(signupEltv13: number, products: string[]) {
  return firePixelEvent("noomSummit", {
    signupEltv13,
    products,
  });
}
